import React, {FC} from "react";
import {Box, BoxProps, Skeleton} from "@mui/material";
import {makeStyles} from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
	itemContent: {
		width: "300px",
		height: "396px",
		background: "#141414",
		border: "1px solid rgba(161, 161, 160, 0.15)",
		display: "flex",
		flexDirection: "column",
		overflow: "hidden",
		boxShadow: theme.shadows[2],
		margin: 4,
		borderRadius: "24px"
	},
	videoThumbnail: {
		height: "260px",
		width: "100%"
	},
	cardContents: {
		display: "flex",
		flexFlow: "wrap",
		height: "calc(100% - 260px)",
		padding: "0px 16px",
		boxSizing: "border-box"
	},
	itemDetailsContainer: {
		margin: "5px 0 15px",
		flexGrow: 1,
		display: "flex",
		gap: "10px",
		flexDirection: "column"
	},
	chipRow: {
		display: "flex",
		gap: "8px"
	}
}));

export const EnrolledCourseCardSkeleton: FC<BoxProps> = ({className, ...props}) => {
	const {classes, cx} = useStyles();

	return (
		<Box
			className={cx(classes.itemContent, className)}
			role="article"
			aria-busy="true"
			{...props}
		>
			<Skeleton
				variant="rectangular"
				className={classes.videoThumbnail}
				animation="wave"
				sx={{borderTopLeftRadius: "16px", borderTopRightRadius: "16px"}}
			/>

			<Box className={classes.cardContents}>
				<Box className={classes.itemDetailsContainer}>
					<Box className={classes.chipRow}>
						<Skeleton
							variant="rounded"
							width={90}
							height={24}
							animation="wave"
						/>
						<Skeleton
							variant="rounded"
							width={120}
							height={24}
							animation="wave"
						/>
					</Box>

					<Skeleton
						variant="text"
						height={32}
						width="100%"
						animation="wave"
					/>
					<Skeleton
						variant="text"
						height={32}
						width="80%"
						animation="wave"
					/>
				</Box>
			</Box>
		</Box>
	);
};
